import React from 'react';
import { ServicePage } from '../components/ServicePage';
import { services } from '../data/site';
const service = services.find(s => s.key === 'chauffage')!;
export function Chauffage() {
  return <ServicePage service={service} note="Les interventions couvrent tous les systèmes de chauffage, quelle que soit leur énergie, ainsi que la climatisation et la ventilation : installation, entretien, dépannage et maintenance." data-id="element-162" data-mp="1fjzlhtbcth6q" />;
}